import React from 'react'
import Skeleton from 'react-loading-skeleton'

const BreadcrumbSkeleton = () => {
  return (
    <div className="mb-4">
      <div className="flex items-center gap-2">
        <Skeleton
          width={60}
          height={16}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
        <Skeleton
          width={8}
          height={16}
          baseColor="#f8fafc"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
        <Skeleton
          width={90}
          height={16}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
        <Skeleton
          width={8}
          height={16}
          baseColor="#f8fafc"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
        <Skeleton
          width={120}
          height={16}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
      </div>
    </div>
  )
}

export default BreadcrumbSkeleton
